/**
 * Created by mateo on 6/29/17.
 */
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'metasSort', standalone: false,})

export class MetasSortPipe implements PipeTransform {
    transform(array, categoria) {
        return array.filter(obj => obj.categoriaID === categoria);
    }
}
